import { matchPath } from 'react-router-dom';
import type { RouteConfig } from '@hs/shared';

type Entry = { pattern: string; title: string; order: number };

function flattenRoutes(routes: RouteConfig[], prefixSegments: string[]): Entry[] {
  const out: Entry[] = [];
  let order = 0;

  function walk(rs: RouteConfig[], segs: string[]) {
    for (const route of rs) {
      let segments = [...segs];
      if (route.path && route.path !== '/') {
        segments = [...segments, ...route.path.split('/').filter(Boolean)];
      }
      const pattern = segments.length === 0 ? '/' : `/${segments.join('/')}`;

      if (route.meta?.title) {
        out.push({ pattern, title: route.meta.title, order });
        order += 1;
      }
      if (route.children) {
        for (const child of route.children) {
          walk([child], segments);
        }
      }
    }
  }

  walk(routes, prefixSegments);
  return out;
}

/**
 * 根据 pathname 在 RouteConfig 树上解析 meta.title（与 BrowserRouter 兼容，不依赖 data router）。
 * 取匹配中最具体的一条：pattern 更长优先；等长时后出现的路由优先（子路由覆盖父级）。
 */
export function matchRouteTitleFromConfig(routes: RouteConfig[], pathname: string): string | undefined {
  const entries = flattenRoutes(routes, []).filter((e) =>
    matchPath({ path: e.pattern, end: true }, pathname),
  );
  if (entries.length === 0) return undefined;

  entries.sort((a, b) => {
    const len = b.pattern.length - a.pattern.length;
    if (len !== 0) return len;
    return b.order - a.order;
  });

  return entries[0]?.title;
}
